import { api, loginapi } from "../APIConfigs";
import { defineCancelApiObject } from "../APIUtils";

export const VerifyAPIs = {


    PostVerifyEmail: async function (email, verificationCode, token, cancel = false){
        const response = await api.request({
            // Here, the url you were using is just slightly wrong. So it needs to match what you are using in postman. 
            // You did really well to console log the errors the API call was getting. It gave status 404 (not found) which usually means the url does not exist / is incorrect
            // url: '/verify/email',

            // This is the url Harsha gave us /portal/verify/email/{email} below is what that looks like in react.
            url: '/school-tour-company/rest/portal/verify/email/' + email,
            method: 'POST',
            headers: {
                // 'Content-Type': 'application/json'       I have changed this value as the content type of Harsha's call in text/plain
                'Content-Type': 'text/plain'
            },

            // I cahnged thiss too. So as you saw in the call with Harsha yesterday, the content / body of the postman call is just a plain text,
            // so no need for the json format. Simply send the verification Code as a string
            // data:{
            //     email: email,
            //     verificationCode: verificationCode,
            //     token: token
            // },
            data: verificationCode,
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },


    PostVerify: async function (token, cancel = false){
        const response = await loginapi.request({
            url: '/verification/' + token,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },

    PostNewVerificationLink: async function (postJSON, cancel = false){
        const response = await api.request({
            url: '/school-tour-company/rest/portal/generatetoken',
            method: 'POST',
            data: postJSON,
            headers: {
                'Content-Type': 'application/json'
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },

    
}
const cancelAPIObject = defineCancelApiObject(VerifyAPIs)